import { EffectCallback, useEffect, useRef } from 'react';

export const useEffectOnce = (effect: EffectCallback): void => {
  const effectRef = useRef<EffectCallback>(effect);
  const isRunRef = useRef(false);

  useEffect(() => {
    effectRef.current = effect;
  });

  useEffect(() => {
    if (!isRunRef.current) {
      isRunRef.current = true;
      return effectRef.current();
    }
  }, []);
};
